<template>
    <div v-if="show" class="comments-container">
        <div class="title">{{ $tc('profile.results.comment', 2) }}</div>
        <div class="comments-wrap">
            <Item
                :key="comment.id"
                v-for="(comment, index) in comments"
                :comment="comment"
                :showDivisor="index !== comments.length - 1"
                @deleted="onDeleteComment"
            />
        </div>
    </div>
</template>
<script>
import Item from './Item'
import { EventBuzz } from '@/main'
import { getUserNBoxComments } from '@/views/n-box/report/api'
export default {
    components: {
        Item,
    },
    props: {
        nBox: {},
        user: {},
    },
    data() {
        return {
            comments: [],
        }
    },
    computed: {
        show() {
            return this.comments.length > 0
        },
    },
    created() {
        EventBuzz.$on('n-box-comment-created', this.onCreateComment)
    },
    destroyed() {
        EventBuzz.$off('n-box-comment-created')
    },
    mounted() {
        this.getComments()
    },
    watch: {
        user() {
            this.onChangeProps()
        },
        nBox() {
            this.onChangeProps()
        },
    },
    methods: {
        onChangeProps() {
            this.setComments([])
            this.getComments()
        },
        getComments() {
            getUserNBoxComments(this.nBox.id, this.user.id).then(comments =>
                this.setComments(comments)
            )
        },
        onCreateComment(comment) {
            const comments = this.addComment(comment)
            this.setComments(comments)
        },
        addComment(comment) {
            return [comment, ...this.comments]
        },
        onDeleteComment(commentId) {
            const comments = this.removeComment(commentId)
            this.setComments(comments)
        },
        removeComment(commentId) {
            return this.comments.filter(c => c.id !== commentId)
        },
        setComments(value) {
            this.comments = value
        },
    },
}
</script>
<style lang="sass" scoped>
.comments-container
    margin-top: 16px

    .title
        font-size: 12px
        text-transform: uppercase

    .comments-wrap
        padding: 8px
        border: 1px solid #c8ced3
        border-radius: 4px
</style>
